import moment from 'moment'
import momentTimezone from 'moment-timezone'
import timezones from 'app/constants/timezones'

// helps to define user's timezone if const timezones doesn't contain it
export const getTimezonesWithGuess = timezone => {
  // get timezone from user or browser
  const currentTZ = timezone || moment.tz.guess()
  if (timezones.find(tz => tz.value === currentTZ)) {
    return timezones
  }
  // get list of all timezones
  const globalTZs = momentTimezone.tz.names()
  const foundTimezoneFromGlobalList = globalTZs.find(tz => tz === currentTZ)
  if (foundTimezoneFromGlobalList) {
    return timezones.map(el => {
      if (moment.tz(el.value).format('Z') === moment.tz(currentTZ).format('Z')) {
        el.value = currentTZ
      }
      return el
    })
  }
  return timezones
}
